<template>
  <b-card>

    <b-row>
      <div class="d-flex flex-row w-100 mb-1">
        <b-col
          cols="8"
          class="d-flex justify-content-between flex-column"
        >
          <!-- Account Avatar -->
          <div class="d-flex justify-content-start align-items-center">
            <b-avatar
              :text="avatarText(accountData.name)"
              :variant="`light-secondary`"
              size="55px"
              rounded
            />
            <div class="d-flex flex-column ml-1">
              <h4>
                {{ accountData.name }}
              </h4>
            </div>
          </div>
        </b-col>

        <b-col
          cols="4"
          class="d-flex justify-content-end"
        >
          <b-dropdown
            variant="link"
            no-caret
            right
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item @click="openAccountStatementModal">
              <span>Acc. Statement</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
      </div>

      <b-col
        cols="12"
        md="8"
      >
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="StarIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Is JURA Account</span>
            </th>
            <td>
              <b-badge
                pill
                :variant="(accountData.isJuraAcc) ? 'light-success' : 'light-secondary'"
                class="text-capitalize"
              >
                {{ (accountData.isJuraAcc) ? 'Yes' : 'No' }}
              </b-badge>
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="StarIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Is GTA Account</span>
            </th>
            <td>
              <b-badge
                pill
                :variant="(accountData.isGtaAcc) ? 'light-success' : 'light-secondary'"
                class="text-capitalize"
              >
                {{ (accountData.isGtaAcc) ? 'Yes' : 'No' }}
              </b-badge>
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="StarIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Is Frontier Account</span>
            </th>
            <td>
              <b-badge
                pill
                :variant="(accountData.isFrontierAcc) ? 'light-success' : 'light-secondary'"
                class="text-capitalize"
              >
                {{ (accountData.isFrontierAcc) ? 'Yes' : 'No' }}
              </b-badge>
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="StarIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Is Bank Account</span>
            </th>
            <td>
              <b-badge
                pill
                :variant="(accountData.isBankAcc) ? 'light-success' : 'light-secondary'"
                class="text-capitalize"
              >
                {{ (accountData.isBankAcc) ? 'Yes' : 'No' }}
              </b-badge>
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <account-statement-modal ref="accountStatementModalRef" />
  </b-card>
</template>

<script>
import { avatarText } from '@core/utils/filter';
import { BAvatar, BBadge, BButton, BCard, BCol, BDropdown, BDropdownItem, BRow } from 'bootstrap-vue';
import { ref } from '@vue/composition-api'
import AccountStatementModal from '@/modules/account/components/modals/AccountStatementModal.vue';

export default {
  props: {
    accountData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const accountStatementModalRef = ref(null);

    const openAccountStatementModal = () => {
      accountStatementModalRef.value.$refs.refModal.show();
    }

    return {
      //Reactive
      accountStatementModalRef,

      //Method
      openAccountStatementModal,

      // Filter
      avatarText,
    };
  },
  components: {
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BCol,
    BDropdown,
    BDropdownItem,
    BRow,
    AccountStatementModal,
  },
};
</script>
